interface PartnersReferrersI {
  [key: string]: PartnersReferrerSettingI;
}

interface PartnersReferrerSettingI {
  campaignStrategy:
    | 'none'
    | 'custom'
    | 'all'
    | 'middle'
    | 'between'
    | 'middle-bottom'
    | 'bottom'
    | 'external'
    | 'internal';
}

const PartnersReferrers: PartnersReferrersI = {
  finviz: {
    campaignStrategy: 'none',
  },
  newsbreak: {
    campaignStrategy: 'none',
  },
  newsbreakapp: {
    campaignStrategy: 'none',
  },
  robinhood: {
    campaignStrategy: 'bottom',
  },
};

export const isUrlHasPartnerReferrerUTMSource = (url: string): boolean => {
  if (!url) {
    return false;
  }

  return Object.keys(PartnersReferrers).some(referrer => url?.includes(`utm_source=${referrer}`));
};

export const getSettings = (utmKey: string) => {
  let setting: string | undefined = undefined;

  if (utmKey) {
    for (const settingKey in PartnersReferrers) {
      if (utmKey.includes(settingKey)) {
        setting = PartnersReferrers[settingKey].campaignStrategy;
        break;
      }
    }
  }

  return setting;
};

export const getCampaignStrategySetting = (partnerKey: string): string | null => {
  return PartnersReferrers[partnerKey]?.campaignStrategy || null;
};

export const getAllRefPartners = (): string[] => {
  return Object.keys(PartnersReferrers);
};
